import { render, staticRenderFns } from "./DetalheTarefasComponent.vue?vue&type=template&id=7ff7c271"
import script from "./DetalheTarefasComponent.vue?vue&type=script&lang=js"
export * from "./DetalheTarefasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports